/**
 * Bouton "En voir plus" (pages Galerie / Flash) : charge le lot de cartes
 * suivant en AJAX (admin-ajax.php, voir helpers/ajax.php) et l'ajoute dans
 * le conteneur ciblé, sans rechargement de page.
 *
 * Composant global (auto-chargé sur toutes les pages, comme Header/Footer) :
 * il ne fait rien si aucun ".js-load-more" n'est présent sur la page.
 */

import { observe as observeParallax } from '&/components/Parallax/Parallax'

export function render ({ wp }) {

  const buttons = document.querySelectorAll('.js-load-more')
  if (!buttons.length) return

  buttons.forEach(btn => initButton(btn, wp))

}

function initButton (btn, wp) {

  btn.addEventListener('click', () => {

    if (btn.disabled) return

    const target = document.querySelector(btn.dataset.target)
    const page = parseInt(btn.dataset.nextPage, 10)
    const label = btn.querySelector('.js-load-more__label')
    const initialLabel = label ? label.textContent : null

    if (!target) return

    btn.disabled = true
    if (label) label.textContent = 'Chargement...'

    const body = new URLSearchParams({
      action: btn.dataset.action,
      nonce: wp.ajax_nonce,
      page
    })

    fetch(wp.ajax_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body
    })
      .then(res => res.json())
      .then(res => {

        if (!res.success) throw new Error('load-more: réponse invalide')

        const { html, has_more } = res.data

        const template = document.createElement('template')
        template.innerHTML = html
        const newItems = Array.from(template.content.children)

        newItems.forEach(item => {
          target.appendChild(item)
          // Les cartes injectées portent déjà "data-parallax" (voir
          // helpers/ajax.php) : il faut juste les brancher, le composant
          // Parallax global ne les a pas vues au chargement de la page.
          observeParallax(item)
        })

        btn.dataset.nextPage = page + 1
        btn.disabled = false
        if (label) label.textContent = initialLabel

        if (!has_more) btn.hidden = true

      })
      .catch(() => {
        btn.disabled = false
        if (label) label.textContent = initialLabel
      })

  })

}
